import { CategoryLinkComponent } from './category-link';
export const CategoryLink = CategoryLinkComponent;